module.exports = __webpack_public_path__ + "img/marmore.3ad6b26a.png";